import React, { useState, useEffect } from "react";
import styled from "styled-components";
import CloseIcon from "../../../assets/icons/x-close0.svg";
import * as Library from "../../../utils/Library";
import NotificationCard from "./NotificationCard";
import NotificationSkeleton from "../loaders/NotificationSkeleton";

//#region Styled Component
const StyledNotificationPanel = styled.div`
    &.items-panel {
        background: var(--backgrounds-and-lines-n-500, #141922);
        padding: 16.5px 16px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: flex-start;
        justify-content: flex-start;
        height: 100vh;
        position: sticky;
        width: 360px;
        overflow: hidden;
    }
    .frame-313273 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .frame-313271 {
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: flex-end;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313329 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .all-notifications {
        color: var(--buttons-all-platforms-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-3-font-size, 20px);
        font-weight: var(--heading-3-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .x-close {
        flex-shrink: 0;
        width: 24px;
        height: 24px;
        position: relative;
        overflow: visible;
        cursor: pointer;
    }
    .frame-313276 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
        overflow: hidden;
    }
    .frame-313330 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .search {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: flex-start;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-48 {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 6px 12px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        height: 37px;
        position: relative;
    }
    .search-list {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: left;
        font-family: "Roboto-Italic", sans-serif;
        font-size: 12px;
        font-weight: 400;
        font-style: italic;
        position: relative;
        height: 100%;
        width: 100%;
        background: transparent;
        border: none;
        outline: none;
    }
    .search-list.has-value {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-style: normal;
    }
    .frame-313333 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
        height: calc(100vh - 120px);
    }
    .frame-313347 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .btn-tabs {
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
        cursor: pointer;
    }
    .frame-309 {
        display: flex;
        flex-direction: column;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .label {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: center;
        font-family: "Roboto-Medium", sans-serif;
        font-size: 14px;
        letter-spacing: 0.015em;
        font-weight: 500;
        text-transform: uppercase;
        position: relative;
    }
    .frame-309.active {
        border-bottom: 3px solid #00aeef;
    }
    .frame-309.active .label {
        color: var(--text-and-icons-blue-500, #00aeef);
    }
    .frame-313311 {
        display: flex;
        flex-direction: column;
        /* gap: 24px; */
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
        overflow-y: auto; /* Enable vertical scrolling */
        height: calc(100vh - 150px); /* Adjust height to fit within the viewport */
        margin-bottom: 15px;
    }
    .frame-1000011390 {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        position: relative;
    }
    .today-1100028 {
        color: var(--buttons-all-platforms-gray-100, #d1d1d1);
        text-align: left;
        font-family: var(--heading-3-font-family, "Roboto-Regular", sans-serif);
        font-size: var(--heading-3-font-size, 20px);
        font-weight: var(--heading-3-font-weight, 400);
        position: relative;
        width: 296px;
        height: 23px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
    }
    .frame-1000011389 {
        display: flex;
        flex-direction: column;
        gap: 0px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        position: relative;
        cursor: pointer;
    }
    .frame-92 {
        border-radius: 4px;
        padding: 8px 16px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        &:hover {
            background-color: #1e2631;
        }
        &:hover .action-group-btn {
            display: flex;
        }
    }
    .frame-1000011384 {
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .ellipse-9 {
        background: var(--text-and-icons-orange-500, #ff9900);
        border-radius: 50%;
        flex-shrink: 0;
        width: 8px;
        height: 8px;
        position: absolute;
        right: 0px;
        top: 0.5px;
    }
    .frame-1000011386 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .retailer-just-sent-a-reorder-check-it-out {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        text-align: left;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 14px;
        font-weight: 400;
        position: relative;
        flex: 1;
    }
    ._2-h {
        color: var(--text-and-icons-gray-200, #7c868b);
        text-align: right;
        font-family: "Roboto-Regular", sans-serif;
        font-size: 12px;
        font-weight: 400;
        position: relative;
    }
    .frame-1000011389--s {
        color: #fff;
    }
    .action-group-btn {
        height: 24px;
        width: 44px;
        background-color: #141922;
        border-radius: 5px;
        padding: 6px;
        display: none;
        flex-direction: row;
        gap: 8px;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 0px;
    }
    .action-group-btn div {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .action-group-btn div.delete:hover svg path {
        stroke: #ff3636;
    }
    .action-group-btn div.read:hover svg path {
        stroke: #00bb00;
    }
`;
//#endregion

export default function NotificationPanel({
    setShowNotificationPanel, // Function to toggle visibility of the notification panel
    groupedUnreadNotifications, // Object containing grouped unread notifications
    readNotifications, // Array of read notifications
    getReadNotifications, // Function to fetch read notifications
    getUnreadNotifications, // Function to fetch unread notifications
    hasNextPage, // Boolean indicating if there are more notifications to load
    readNotificationCount, // Function to get the count of read notifications
    isLoading, // Boolean indicating if notifications are being loaded
    handleDestinationPage, // Function to handle navigation to a specific page
    loadMoreLoading // Boolean indicating if more notifications are being loaded
}) {
    //#region State Management
    const [activeTab, setActiveTab] = useState("UNREAD"); // State to track the active tab
    const [page, setPage] = useState(1); // State to track the current page for pagination
    const [searchText, setSearchText] = useState("");
    //#endregion

    //#region Handlers
    const handleTabClick = tab => {
        setActiveTab(tab);
        setPage(1); // Reset page when switching tabs
    };

    const handleNotificationSearch = searchText => {
        setSearchText(searchText);
        if (searchText) {
            if (activeTab === "UNREAD") {
                getUnreadNotifications(1, 20, searchText);
            } else {
                getReadNotifications(1, 20, searchText);
            }
        } else {
            if (activeTab === "UNREAD") {
                getUnreadNotifications(1, 20);
            } else {
                getReadNotifications(1, 20);
            }
        }
    };

    const loadMoreNotifications = () => {
        if (hasNextPage) {
            const nextPage = page + 1;
            setPage(nextPage);
            if (activeTab === "UNREAD") {
                getUnreadNotifications(nextPage, 20);
            } else {
                getReadNotifications(nextPage, 20);
            }
        }
    };

    const handleDeleteNotification = notificationID => {
        Library.makeCommonPostRequest(
            "Global",
            "deleteNotifications",
            {
                notificationIDs: [notificationID]
            },
            false,
            null
        ).then(res => {
            if (activeTab === "UNREAD") {
                getUnreadNotifications(1, 20);
            } else {
                getReadNotifications(1, 20);
            }
        });
    };

    const handleReadNotification = notificationID => {
        Library.makeCommonPostRequest(
            "Global",
            "updateNotificationsStatus",
            {
                notificationIDs: [notificationID],
                status: "Seen"
            },
            false,
            null
        ).then(res => {
            if (activeTab === "UNREAD") {
                getUnreadNotifications(1, 20);
            } else {
                getReadNotifications(1, 20);
            }
        });
    };

    const handleScroll = e => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop === clientHeight || scrollHeight - scrollTop < clientHeight) {
            loadMoreNotifications();
        }
    };

    //#endregion

    //#region Effects
    useEffect(() => {
        const container = document.querySelector(".frame-313311"); // Updated to target the correct scrollable container
        if (container) {
            container.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (container) {
                container.removeEventListener("scroll", handleScroll);
            }
        };
    }, [page, hasNextPage, activeTab]); // Added activeTab to dependencies to ensure proper updates
    //#endregion

    //#region Calculations

    const sortedKeys = groupedUnreadNotifications?.["Today"]
        ? ["Today", ...Object.keys(groupedUnreadNotifications).filter(key => key !== "Today")]
        : Object.keys(groupedUnreadNotifications || {});
    //#endregion

    //#region Render
    return (
        <StyledNotificationPanel className="items-panel">
            {/* Header section */}
            <div className="frame-313273">
                <div className="frame-313271">
                    <div className="frame-313329">
                        <div className="all-notifications">All Notifications</div>
                        <img
                            className="x-close"
                            src={CloseIcon}
                            alt="CloseIcon"
                            onClick={() => setShowNotificationPanel(false)} // Close the notification panel
                        />
                    </div>
                </div>
                {/* Search and tab section */}
                <div className="frame-313276">
                    <div className="frame-313330">
                        <div className="search">
                            <div className="frame-48">
                                <input
                                    type="text"
                                    className={`search-list ${searchText ? "has-value" : ""}`}
                                    placeholder="Search notifications"
                                    value={searchText}
                                    onChange={e => handleNotificationSearch(e.target.value)}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="frame-313333">
                        <div className="frame-313347">
                            {/* UNREAD tab */}
                            <div
                                className="btn-tabs"
                                onClick={() => {
                                    handleTabClick("UNREAD");
                                    getUnreadNotifications(1, 20, searchText ? searchText : undefined);
                                }}>
                                <div className={`frame-309 ${activeTab === "UNREAD" ? "active" : ""}`}>
                                    <div className="label">
                                        UNREAD ({readNotificationCount ? readNotificationCount : 0})
                                    </div>
                                </div>
                            </div>
                            {/* READ tab */}
                            <div
                                className="btn-tabs"
                                onClick={() => {
                                    handleTabClick("READ");
                                    getReadNotifications(1, 20, searchText ? searchText : undefined);
                                }}>
                                <div className={`frame-309 ${activeTab === "READ" ? "active" : ""}`}>
                                    <div className="label">ALL</div>
                                </div>
                            </div>
                        </div>
                        {/* Notification list */}
                        {activeTab === "UNREAD" ? (
                            <div className="frame-313311" style={{ gap: isLoading && page === 1 ? "15px" : "0px" }}>
                                {isLoading && page === 1 ? (
                                    <NotificationSkeleton count={5} />
                                ) : (
                                    <>
                                        {Object.keys(groupedUnreadNotifications).length === 0 ||
                                        sortedKeys.every(key => groupedUnreadNotifications[key].length === 0) ? (
                                            <div className="frame-1000011390">
                                                <div className="retailer-just-sent-a-reorder-check-it-out">
                                                    There are no notifications.
                                                </div>
                                            </div>
                                        ) : (
                                            sortedKeys.map(label => (
                                                <div key={label} className="frame-1000011390">
                                                    <div className="today-1100028">{label}</div>
                                                    {groupedUnreadNotifications?.[label]?.map(notification => (
                                                        <NotificationCard
                                                            handleDeleteNotification={handleDeleteNotification}
                                                            notification={notification}
                                                            handleReadNotification={handleReadNotification}
                                                            handleDestinationPage={handleDestinationPage}
                                                            actionBtn={{
                                                                read: true,
                                                                delete: true
                                                            }}
                                                        />
                                                    ))}
                                                </div>
                                            ))
                                        )}
                                        {loadMoreLoading && <NotificationSkeleton count={20} />}
                                    </>
                                )}
                            </div>
                        ) : (
                            <div className="frame-313311" style={{ gap: isLoading && page === 1 ? "15px" : "0px" }}>
                                {isLoading && page === 1 ? (
                                    <NotificationSkeleton count={5} />
                                ) : (
                                    <>
                                        {readNotifications?.length === 0 ? (
                                            <div className="frame-1000011390">
                                                <div className="retailer-just-sent-a-reorder-check-it-out">
                                                    There are no notifications.
                                                </div>
                                            </div>
                                        ) : (
                                            readNotifications?.map(notification => (
                                                <NotificationCard
                                                    handleDeleteNotification={handleDeleteNotification}
                                                    notification={notification}
                                                    handleReadNotification={handleReadNotification}
                                                    handleDestinationPage={handleDestinationPage}
                                                    actionBtn={{
                                                        read: true,
                                                        delete: notification?.status !== "Seen"
                                                    }}
                                                    showDotOverBell={notification?.status !== "Seen"} // Hide the dot over the bell icon for read notifications
                                                />
                                            ))
                                        )}
                                        {loadMoreLoading && <NotificationSkeleton count={20} />}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </StyledNotificationPanel>
    );
    //#endregion
}
